import {registerLocaleData} from "@angular/common";
import {ApplicationConfig, importProvidersFrom, LOCALE_ID} from "@angular/core";
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import {provideRouter, withInMemoryScrolling} from "@angular/router";
import {provideHttpClient} from "@angular/common/http";
import {ToastrModule} from "ngx-toastr";
import {ModalModule} from "ngx-bootstrap/modal";
import {routes} from "./app.routes";
import {provideAnimations} from "@angular/platform-browser/animations";
import {provideCharts, withDefaultRegisterables} from 'ng2-charts';

registerLocaleData(localeDe);
registerLocaleData(localeEn);

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes, withInMemoryScrolling({
            scrollPositionRestoration: 'top'
        })),
        provideHttpClient(),
        provideAnimations(),
        provideCharts(withDefaultRegisterables()),
        importProvidersFrom(
            ToastrModule.forRoot(),
            ModalModule.forRoot(),
        ),
        {
            provide: LOCALE_ID,
            useValue: 'de-DE'
        }
    ]
};
